/**
 * Generated bundle index. Do not edit.
 */

export {McBreadcrumbsComponent,McBreadcrumbsService,McBreadcrumbsConfig,IBreadcrumb,McBreadcrumbsResolver,McBreadcrumbsModule} from './index';
